import { FC } from 'react'

import Section from '@/components/atomic/molecules/Section'
import ReviewTemplate from '@/components/atomic/templates/ReviewTemplate'
import { postAmplitude } from '@/core/lib'
import { useTranslation } from '@/lang'
import { AirbridgeEvents, sendAirbridgeEvent } from '@/utils/airbridge'
import { Locales } from '@/utils/language'

import type { ReviewsPaginationResponseInternal } from '@/features/review/api/review.type'
import type { HospitalView } from '@/features/hospital/types/hospital.type'

interface HospitalReviewSectionProps {
  reviewWithPagination?: ReviewsPaginationResponseInternal
  hospital: HospitalView
  isAnonymousUser: boolean
  locale: Locales
  commonAmplitudeProperties: {
    hospital_id: number
    hospital_name: string
    hospital_region: string
  }
}

export const HospitalReviewSection: FC<HospitalReviewSectionProps> = ({
  reviewWithPagination,
  hospital,
  isAnonymousUser,
  locale,
  commonAmplitudeProperties,
}) => {
  const { t } = useTranslation()

  return (
    <Section padding={26} className="border-t border-gray-200" style={{ padding: '26px' }}>
      <ReviewTemplate
        title={t('templates.hospitalDetail.reviewTitle')}
        total={reviewWithPagination?.totalElementNumber || hospital.statistic.reviewCount}
        hospitalId={hospital.hospitalId}
        urlClickMore={`/reviews?hospitalId=${hospital.hospitalId}`}
        reviews={reviewWithPagination?.contents}
        isUser={!isAnonymousUser || locale === Locales.JA_JP}
        onClickMoreReview={() => {
          postAmplitude('click_more_review_in_hospital_detail', commonAmplitudeProperties)
        }}
        onClickReviewCard={() => {
          sendAirbridgeEvent(AirbridgeEvents.REVIEW_HOSPITALPAGE_CLICK, {
            semanticAttributes: {
              products: [
                {
                  brandID: hospital.hospitalId,
                  brandName: hospital.name,
                },
              ],
            },
          })
        }}
        onClickLoginButton={() => {
          sendAirbridgeEvent(AirbridgeEvents.SIGN_UP_BUTTON_CLICK_IN_WEB, {})
          postAmplitude('click_login_review_module_in_hospital_detail', commonAmplitudeProperties)
        }}
      />
    </Section>
  )
}

export default HospitalReviewSection
